import classes from './MainNavigationBar.module.css.mjs';

const mainNavigationBarVariantClasses = {
  "v2.1": classes.mainNavGlobal,
  universal: classes.mainNavUniversal
};

export { mainNavigationBarVariantClasses };
